import {types} from './types';

const setWithdrawalsAction = (payload) => {
    return {
        type: types.SET_WITHDRAWALS,
        payload,
      }
}

export {
  setWithdrawalsAction
}